module.exports = __webpack_public_path__ + "media/images/common/icon-phone-0d25ffd62d63884645aacb258518b8e0.png";